import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextbookModule } from '@app/textbook/textbook.module';
import { TextbookInfographicManagerProvider } from '@app/core/providers/textbook-manager.provider';

@NgModule({
  declarations: [],
  imports: [CommonModule, TextbookModule],
  providers: [TextbookInfographicManagerProvider],
})
export class TextbookInfographicsVersionModule {}
